import { Fragment, useEffect, useRef, useState } from "react";
import { isValidArray } from "../../Layout/Common/common";
import { CSSTransition, TransitionGroup } from "react-transition-group";

export const ErrorItem = ({ errItem }) => {
  const [errorItem, setErrorItem] = useState(null);
  const currentErrorRef = useRef(null);
  useEffect(() => {
    if (isValidArray(errItem)) {
      errItem.forEach((item, index) => {
        setTimeout(() => {
          setErrorItem((prevCards) => (prevCards ? [...prevCards, item] : [item]));
          if (currentErrorRef.current) {
            currentErrorRef.current.focus();
          }
        }, index * 100);
      });
    } else {
      setErrorItem(null);
    }
  }, [errItem]);
  return (
    <Fragment>
      {errorItem && (
        <div className="order-clarification not-found" ref={currentErrorRef}>
          <div className="order-clarification-lft quick-order">
            <TransitionGroup>
              {errorItem.map((item, index) => (
                <CSSTransition key={item.sku + index} timeout={700} classNames="card">
                  <h5 style={{ width: "auto" }}>
                    <span className="wes-alert" /> <b>{`"${item.sku}"`}</b>
                    {`${item.message}`}
                  </h5>
                </CSSTransition>
              ))}
            </TransitionGroup>
          </div>
        </div>
      )}
    </Fragment>
  );
};
